import React, { ReactNode } from 'react';
import { omit } from 'lodash';

import styles from './input.module.scss';
import { IoCloudUploadOutline } from 'react-icons/io5';
import '../../theme/global.scss';
import { Tooltip } from 'antd';
import { combineFilesNames } from '../../utils/strings';
interface IInput {
  label: ReactNode;
  id: string;
  placeholder?: string;
  icon?: ReactNode;
  ending?: ReactNode;
  name: string;
  value?: FileList;
  required?: boolean;
  checked?: boolean;
  title?: string;
  endingStyle?: any;
  style?: any;
  onChange?: (e: React.ChangeEvent<any>) => void;
}
const CUpload = (props: IInput) => {
  const { value, ...input } = props;

  return (
    <>
      <section className={styles.sectionUpload} style={props.style}>
        <span className={styles.ending} style={props.endingStyle}>
          <IoCloudUploadOutline />
        </span>
        <label htmlFor={props.id} className={styles.label}>
          {props.label}
        </label>
        {/* <label> */}

        <Tooltip
          title={
            props.value ? combineFilesNames(props.value) : 'Încărcați fișier'
          }
        >
          <input
            className={styles.input + ' ' + styles.file}
            {...omit(input, 'endingStyle')}
            type='file'
            id='upload'
            data-content={
              props.value && props.value.length > 0
                ? combineFilesNames(props.value)
                : props.title
                ? props.title
                : 'Încărcați fișier'
            }
            multiple
          />
        </Tooltip>
        {/* </label> */}
      </section>
      {/* <CButton
        label='Adaugă încă un fișier'
        onClick={() => null}
        type='button'
      /> */}
    </>
  );
};

export default CUpload;
